import type { StudioCapabilities, StudioLanguage } from '@neotech-solutions-org/sanity-cms';
import { PERMISSIONS } from '../../constants/keycloak';
import type { LanguageConfig } from '../languages';

type CreateStudioCapabilitiesOptions = {
  permissions: string[];
  isStandaloneCasino: boolean;
  promotionsEnabled: boolean;
};

export const createStudioCapabilities = ({
  permissions,
  isStandaloneCasino,
  promotionsEnabled,
}: CreateStudioCapabilitiesOptions): StudioCapabilities => ({
  sportsbookContent: permissions.includes(PERMISSIONS.sportsbookCMS),
  casinoContent: permissions.includes(PERMISSIONS.casinoCMS),
  promotions: promotionsEnabled,
  standaloneCasino: isStandaloneCasino,
});

export const createStudioLanguages = (languages: LanguageConfig): StudioLanguage[] =>
  languages.map(({ key, label }) => ({
    id: key,
    title: label,
    isDefault: key === 'en',
  }));
